import React, {useEffect, useState} from 'react';
import {requestDeleteGroup} from "@app/services/CandidateGroupService";
import {toast} from "react-toastify";
import {CannotEditPipelinesWithInternalProcess, JobPipelineTableColumns} from "@pages/jobpipeline/common/Constant";
import InputMoreModal from "@pages/candidate/commonview/InputMoreModal";
import {requestDeleteJobPipeline, requestSaveJobPipeline} from "@app/services/JobPipelineService";
import {LOCAL_STORAGE_USER_LOGIN_INFO, ODER_BY_TYPE, ResponseCode} from "@app/constants/Common";
import {alertMessage} from "@app/constants/Messages";
import Button from "@app/components/button/Button";
import RefereeConfirmModal from "@pages/candidate/commonview/RefereeConfirmModal";
import PipelineRefereeInputModal from "@pages/jobpipeline/list/PipelineRefereeInputModal";
import {capitalizeName} from "@app/utils/CommonUtils";


const CHANGE_COLOR_COLUMNS = ['interactive_channel', 'ctv_status', 'process_info_from_ctv',
    'refer_status', 'refer_info_process', 'cdd_status', 'user_qualify_uv',
    'todo_with_person',
    'internal_process', 'cdd_to_employer_process', 'payment_and_warranty']

const JobPipeLineTableList = (props) => {
    const [pipeLineList, setPipeLineList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectRow, setSelectRow] = useState({});
    const [showInputMoreModal, setShowInputMoreModal] = useState(false);
    const [hiddenColumns, setHiddenColumns] = useState({});
    const [inputMoreColumn, setInputMoreColumn] = useState({rowIndex: -1, column: {}});
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [sortColumnInfo, setSortColumnInfo] = useState({});
    const [showRefereeConfirmModal, setShowRefereeConfirmModal] = useState(false);
    const [showRefereeInputModal, setShowRefereeInputModal] = useState(false);
    const [showBtnAddPipeline, setShowBtnAddPipeline] = useState(false);

    const {pipeLines, hideColumns, sortColumn, mode, showBtnAddPipelineOnRefereeInput,
        onEditItem, onClose, onSort} = props

    useEffect(() => {
        const strUserLogin = localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)
        if (!userLoginInfo.id && strUserLogin) {
            setUserLoginInfo(JSON.parse(strUserLogin))
        }
    }, [])

    useEffect(() => {
        setPipeLineList([...pipeLines])
    }, [pipeLines]);

    useEffect(() => {
        setSortColumnInfo({...sortColumn})
    }, [sortColumn]);

    useEffect(() => {
        if (hideColumns) {
            setHiddenColumns({...hideColumns})
        }
    }, [hideColumns]);

    useEffect(() => {
        setShowBtnAddPipeline(showBtnAddPipelineOnRefereeInput)
    }, [showBtnAddPipelineOnRefereeInput]);

    const onDeletePipeLine = (id) => {
        let text = "Bạn chắc chắn muốn xóa Job Pipeline này?";
        if (window.confirm(text) === true) {
            setIsLoading(true)
            requestDeleteJobPipeline({id: id}).then((res) => {
                alertMessage(res.sts_code, false, true)
                onClose(true)
            }).catch((error) => {
                console.log(`Error:${JSON.stringify(error)}`);
            }).finally(() => {
                setIsLoading(false)
            });
        }
    }

    const onDeleteItem = (item, index) => {
        setSelectRow(item)
        onDeletePipeLine(item.id)
    }

    const onDuplicateItem = (item) => {
        const newItem = {...item}
        newItem.id = ""
        // ko clone employer_id vì khi duplicate thì sẽ tạo mới pipeline
        newItem.employer_id = ""
        onEditItem(newItem)
    }

    const onShowInputMoreColumn = (fieldKey, index) => {
        const columns = JobPipelineTableColumns.filter(item => {
            return item.key === fieldKey
        })
        setInputMoreColumn({rowIndex: index, column: columns[0]})
        setShowInputMoreModal(true)
    }

    const onCloseInputMoreColumn = () => {
        setInputMoreColumn({rowIndex: -1, column: {}})
        setShowInputMoreModal(false)
    }

    const onSaveInputMore = (value) => {
        console.log("onSaveInputMore:" + value)
        const fieldKey = inputMoreColumn.column.key
        const selectJP = pipeLineList[inputMoreColumn.rowIndex]
        const body = {id: selectJP.id, job_id: selectJP.job_id, candidate_id: selectJP.candidate_id}
        body[fieldKey] = value
        setIsLoading(true);
        requestSaveJobPipeline(body).then((res) => {
            selectJP[fieldKey] = value
            setPipeLineList([...pipeLineList])
            onCloseInputMoreColumn();
            alertMessage(res.sts_code, false, true)
        }).catch((error) => {
            console.log(`Error:${JSON.stringify(error)}`);
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const onShowConfirmRefereeModal = (item) => {
        setSelectRow(item)
        setShowRefereeConfirmModal(true)
    }

    const onShowInputRefereeModal = (confirmInput) => {
        selectRow.confirmInputReferee = confirmInput
        setSelectRow({...selectRow})
        setShowRefereeConfirmModal(false)
        setShowRefereeInputModal(true);
    }

    const onFinishInputReferee = (newCandidateId, refereePipelineId) => {
        const newItem = {
            id: "",
            job_id: selectRow.job_id,
            job_name: selectRow.job_name,
            candidate_id: newCandidateId,
            referer_id: selectRow.candidate_id,
            comment_from_referer: selectRow.confirmInputReferee?.commentAboutPerson,
            internal_process: "target",

            // pipeline id gốc, record mà user lick vào action nhập referee
            // Khi lưu, nếu truyền thông tin origin_pipeline_id lên server, pm sẽ update referee_id
            // của pipeline gốc(id=origin_pipeline_id) thành newCandidateId
            origin_pipeline_id: selectRow.id
        }
        onEditItem(newItem, true)
    }

    const onClickSortColumn = (column) => {
        if (onSort) {
            onSort(column.key)
        }
    }

    const classSortingType = (column) => {
        const sortType = sortColumn[column.key]
        if (sortType) {
            return sortType === ODER_BY_TYPE.DESC ? 'sorting_desc' : 'sorting_asc'
        }

        return ""
    }

    const displayColumnValue = (column, value) => {
        if (value && column.capitalize) {
            return capitalizeName(value)
        }

        return value
    }

    const bgCellColor = (column, changeFields) => {
        if (CHANGE_COLOR_COLUMNS.includes(column.key) && changeFields && changeFields.length > 0 && changeFields.includes(column.key)) {
            return "bg-warning"
        }
        return ""
    }

    return (
        <>
            <table
                className='table table-bordered table-hover dataTable dtr-inline text-nowrap text-center table-responsive'
                style={{minHeight: '70vh'}}
            >
                <thead>
                <tr>
                    <th className={""}>No.</th>
                    {JobPipelineTableColumns.map(item => {
                        if (!hideColumns[item.key]) {
                            return <th className={`sorting ${classSortingType(item)}`}
                                       onClick={() => onClickSortColumn(item)}
                                       key={`JobPipelineTableColumns_th_${item.key}`}>{item.label}</th>
                        }
                        return ""
                    })}
                    <th className={""} style={{minWidth: 83}}>Hành động</th>
                </tr>
                </thead>
                <tbody>
                {pipeLineList && pipeLineList.length > 0 && pipeLineList.map((item, index) => {
                    // Check xem item có thể edit được hay không
                    let canEdit = (userLoginInfo.is_superuser || (userLoginInfo.id === item.created_user
                        && !CannotEditPipelinesWithInternalProcess.includes(item.internal_process) && !item.is_over_allow_edit_time));
                    let changeFields = item.change_fields
                    // let strChangeFields = item.change_fields
                    // // Get thông tin fields change để setting màu sắc
                    // if (strChangeFields) {
                    //     changeFields = JSON.parse(strChangeFields)['fields']
                    // }
                    return <tr key={`jobpipeline_${index}`}>
                        <td className={'text-center'}>{item.no ? item.no : index + 1}</td>
                        {JobPipelineTableColumns.map(field => {
                            if (!hideColumns[field.key]) {
                                if (field.displayType === 'link') {
                                    return <td className={`${field.classNames} text-truncate ${bgCellColor(field, changeFields)}`} style={{maxWidth: 200}}
                                               key={`piplentablelist_row_${index}_column_${field.key}`}>
                                        <a href={`${field.link}${item[field.key]}`} target="_blank"
                                           rel="noreferrer"
                                           className={'text-primary font-weight-bold'}>{displayColumnValue(field, item[field.key])}</a>
                                    </td>
                                }
                                return <td className={`${field.classNames} text-truncate ${bgCellColor(field, changeFields)} ${field.color ? field.color : ''}`} style={{maxWidth: 200}}
                                           key={`piplentablelist_row_${index}_column_${field.key}`}>
                                    {displayColumnValue(field, item[field.key])}
                                </td>
                            }
                            return ""
                        })}
                        <td className={"table-action-column-right-fixed"}>
                            <div className="btn-group">
                                <button type="button" className="btn btn-info">Actions</button>
                                <button type="button" className="btn btn-info dropdown-toggle dropdown-icon"
                                        data-toggle="dropdown">
                                    <span className="sr-only">Toggle Dropdown</span>
                                </button>
                                <div className="dropdown-menu" role="menu">
                                    <>
                                        <Button onClick={() => onEditItem(item)}
                                                disabled={!canEdit}
                                                className={'dropdown-item mr-2'}>
                                            Edit
                                        </Button>
                                        <Button onClick={() => onDuplicateItem(item)}
                                                className={'dropdown-item mr-2'}>
                                            Duplicate
                                        </Button>
                                        <Button onClick={() => onDeleteItem(item, index)}
                                                disabled={!userLoginInfo.is_superuser}
                                           className={'dropdown-item'}>
                                            Xóa
                                        </Button>
                                        <Button onClick={() => {onShowConfirmRefereeModal(item)}}
                                                disabled={!canEdit}
                                                className={'dropdown-item mr-2'}>
                                            Nhập Referee
                                        </Button>
                                        <Button onClick={() => {}}
                                                disabled={!canEdit}
                                                className={'dropdown-item mr-2'}>
                                            Email link
                                        </Button>
                                        <Button onClick={() => {
                                            onShowInputMoreColumn('discussion_with_person_note', index)
                                        }} disabled={!canEdit} className={'dropdown-item mr-2'}>
                                            Note Discussion w Person
                                        </Button>
                                        <Button onClick={() => {
                                            onShowInputMoreColumn('discussion_w_employer_note', index)
                                        }} disabled={!canEdit} className={'dropdown-item mr-2'}>
                                            Note Discussion w Employer
                                        </Button>
                                    </>
                                </div>
                            </div>
                        </td>
                    </tr>
                })}
                </tbody>
            </table>
            {inputMoreColumn.rowIndex > -1 &&
                <InputMoreModal isShow={showInputMoreModal}
                                onClose={() => onCloseInputMoreColumn()}
                                onSave={(input) => onSaveInputMore(input)}
                                fieldTitle={inputMoreColumn.column?.label}
                                inputValue={pipeLineList[inputMoreColumn.rowIndex][inputMoreColumn.column?.key]}/>
            }
            {showRefereeConfirmModal &&
            <RefereeConfirmModal isShow={showRefereeConfirmModal}
                                 refererId={selectRow.candidate_id}
                                 jobId={selectRow.job_id}
                                 isFromPipeline
                                 onNext={(confirmInput) => {onShowInputRefereeModal(confirmInput)}}
                                 onClose={() => {setShowRefereeConfirmModal(false)}}
            />
            }
            {showRefereeInputModal &&
            <PipelineRefereeInputModal isShow={showRefereeInputModal}
                                       showBtnAddPipeline={showBtnAddPipeline}
                                       jobPipeline={selectRow}
                                       onNext={(newCandidateId, refereePipelineId) => onFinishInputReferee(newCandidateId, refereePipelineId)}
                                       onClose={() => {
                                           setShowRefereeInputModal(false)
                                       }}
            />
            }
        </>
    );
};

export default JobPipeLineTableList;
